export const insuranceCompanies = [
  {
    label: "AGRO",
    value: "AGRO",
  },
  {
    label: "ALLIANZ",
    value: "ALLIANZ",
  },
  {
    label: "COMPENSA",
    value: "COMPENSA",
  },
  {
    label: "PZU CENTRALA",
    value: "PZU CENTRALA",
  },
  {
    label: "LINK 4",
    value: "LINK 4",
  },
  {
    label: "HESTIA CENTRALA",
    value: "HESTIA CENTRALA",
  },
  {
    label: "WARTA TUIR",
    value: "WARTA TUIR",
  },
  {
    label: "INTERRISK",
    value: "INTERRISK",
  },
  {
    label: "UNIQA",
    value: "UNIQA",
  },
  {
    label: "GENERALI",
    value: "GENERALI",
  },
  {
    label: "WIENER TU",
    value: "WIENER TU",
  },
  {
    label: "TUZ TUW",
    value: "TUZ TUW",
  },
  {
    label: "GREENVAL",
    value: "GREENVAL",
  },
  {
    label: "KOOPERATIVA POJISTOVNA A.S",
    value: "KOOPERATIVA POJISTOVNA A.S",
  },
  {
    label: "EUROINS UBEZPIECZENIA",
    value: "EUROINS UBEZPIECZENIA",
  },
  {
    label: "BALCIA INSURANCE SE ODDZIAŁ POLSKA",
    value: "BALCIA INSURANCE SE ODDZIAŁ POLSKA",
  },
  {
    label: "PKO",
    value: "PKO",
  },
  {
    label: "UWEX",
    value: "UWEX",
  },
  {
    label: "TOWARZYSTWO UBEZPIECZEN WZAJEMNYCH BIURO REGIONALNE RZESZÓW",
    value: "TOWARZYSTWO UBEZPIECZEN WZAJEMNYCH BIURO REGIONALNE RZESZÓW",
  },
  {
    label: "INNY UBEZPIECZYCIEL",
    value: "Wpisz innego ubezpieczyciela",
  },
];
